import AdminAddPasein from "../../components/AdminMedicalItem/AdminMedicalItemAdd";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminAddPasein/>
    </div>
  );
}
